"use client";
import { useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useSelector, useDispatch } from "react-redux";

import { triggerInfoBarOpened, triggerBackButtonVisibility } from "@/src/store/stickyInfoBar";

import styles from "./styles.module.css";

const StickyInfoBar = ({ isOpened, closeTimer, icon, actionText, handleActionButton, content }) => {
  const dispatch = useDispatch();
  const stickyBarReduxState = useSelector((state) => state.stickyInfoBar.isOpened);

  const wrapperClassess = classNames({
    [styles.wrapper]: true,
    [styles.wrapperOpened]: isOpened,
  });

  useEffect(() => {
    if (stickyBarReduxState === true) {
      const triggerTimeout = setTimeout(() => {
        dispatch(triggerInfoBarOpened());
        dispatch(triggerBackButtonVisibility(true));
      }, closeTimer || 3000);
      return () => clearTimeout(triggerTimeout);
    }
  }, [stickyBarReduxState]);

  return (
    <div className={wrapperClassess}>
      <div className={styles.inner}>
        {icon && <div className={styles.iconWrap}>{icon}</div>}
        <div className={styles.content} dangerouslySetInnerHTML={{ __html: content }} />
        {actionText && (
          <span className={styles.action} onClick={handleActionButton}>
            {actionText}
          </span>
        )}
      </div>
    </div>
  );
};

StickyInfoBar.propTypes = {
  isOpened: PropTypes.bool,
  closeTimer: PropTypes.number,
  icon: PropTypes.element,
  actionText: PropTypes.string,
  handleActionButton: PropTypes.func,
  content: PropTypes.node,
};

export default StickyInfoBar;
